/* v4: resume after app/tab switches; preserve manual pause and autoplay preferences. */
if (!customElements.get('pp-video-hero')) customElements.define('pp-video-hero', class extends HTMLElement {
 connectedCallback() {
  // Editor HTML can connect before its child nodes have been inserted.
  if (!this.init()) {
   this.childObserver = new MutationObserver(() => { if (this.init()) this.childObserver.disconnect(); });
   this.childObserver.observe(this, {childList:true, subtree:true});
  }
 }
 init() {
  if (this.ready) return true;
  const config = this.querySelector('[data-pvh-sources]');
  this.video = this.querySelector('video'); this.button = this.querySelector('.pvh-toggle');
  if (!config || !config.textContent.trim() || !this.video || !this.button) return false;
  try { this.sources = JSON.parse(config.textContent); } catch (_) { return false; }
  this.ready = true; this.abort = new AbortController(); const signal = this.abort.signal;
  this.small = matchMedia('(max-width:749px)'); this.reduced = matchMedia('(prefers-reduced-motion:reduce)');
  this.manualPause = false; this.visible = true; this.forced = false; this.pending = false; this.generation = 0; this.suspended = false; this.resumeTimers = [];
  this.video.muted = true; this.video.defaultMuted = true; this.video.playsInline = true;
  this.button.addEventListener('click', () => {
   if (!this.video.paused) { this.manualPause = true; this.cancelResume(); this.stop(); }
   else { this.manualPause = false; this.forced = true; this.play(); }
  }, {signal});
  this.video.addEventListener('playing', () => { this.setAttribute('data-playing',''); this.setControl('Sæt video på pause', false); }, {signal});
  this.video.addEventListener('pause', () => { this.setControl('Afspil video', true); }, {signal});
  this.video.addEventListener('error', () => { this.removeAttribute('data-playing'); this.setControl('Prøv at afspille igen', true); }, {signal});
  document.addEventListener('visibilitychange', () => {
   if (document.hidden) this.suspend();
   else this.resume();
  }, {signal});
  window.addEventListener('pagehide', () => this.suspend(), {signal});
  window.addEventListener('pageshow', () => this.resume(), {signal});
  window.addEventListener('focus', () => { if (!document.hidden) this.resume(); }, {signal});
  this.small.addEventListener('change', () => this.select(), {signal});
  this.reduced.addEventListener('change', () => { this.forced = false; this.select(); }, {signal});
  if ('IntersectionObserver' in window) {
   this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.update(); }); this.observer.observe(this);
  }
  this.select(); document.querySelector('.header[is="sticky-header"],.header[is="custom-header"]')?.init?.();
  return true;
 }
 setControl(label, paused) {
  this.button.setAttribute('aria-label', label); this.button.title = label; this.button.toggleAttribute('data-paused', paused);
 }
 select() {
  this.generation++; this.pending = false; this.video.pause(); this.removeAttribute('data-playing'); this.video.removeAttribute('src'); this.video.load();
  const desktop = Array.isArray(this.sources.desktop) ? this.sources.desktop : [];
  const mobile = Array.isArray(this.sources.mobile) ? this.sources.mobile : [];
  let candidates = this.small.matches && mobile.length ? mobile : desktop.length ? desktop : mobile;
  candidates = candidates.filter(s => typeof s.url === 'string' && (s.mime_type === 'video/mp4' || s.format === 'mp4' || /\.mp4(?:\?|$)/i.test(s.url))).sort((a,b) => Number(a.height)-Number(b.height));
  this.source = candidates.find(s => Number(s.height) >= (this.small.matches ? 720 : 1080)) || candidates[candidates.length-1];
  this.button.hidden = !this.source; this.setControl('Afspil video', true); this.update();
 }
 cancelResume() {
  this.resumeTimers.forEach(clearTimeout); this.resumeTimers = [];
 }
 stop() {
  // A backgrounded browser may leave an old play() promise unsettled.
  this.generation++; this.pending = false; this.video.pause();
 }
 suspend() {
  this.suspended = true; this.cancelResume(); this.stop();
 }
 resume() {
  if (!this.isConnected || document.hidden) return;
  this.suspended = false; this.cancelResume();
  this.generation++; this.pending = false; this.update();
  // Allow the media session to wake up before retrying. Never reload the
  // source here: keep the current frame/time and avoid a white flash.
  [250, 1000, 2000].forEach(delay => {
   this.resumeTimers.push(setTimeout(() => {
    if (!this.isConnected || document.hidden || this.suspended) return;
    if (this.video.paused) { this.generation++; this.pending = false; this.update(); }
   }, delay));
  });
 }
 update() {
  if (this.suspended || document.hidden || !this.visible || this.manualPause || (!this.forced && (this.reduced.matches || navigator.connection?.saveData || this.dataset.autoplay !== 'true'))) { this.stop(); return; }
  this.play();
 }
 play() {
  if (!this.source || this.pending || !this.video.paused) return;
  if (!this.video.getAttribute('src') || this.video.error) { this.video.src = this.source.url; this.video.load(); }
  this.video.muted = true; this.pending = true; const generation = this.generation;
  let attempt;
  try { attempt = this.video.play(); } catch (_) { this.pending = false; this.setControl('Afspil video', true); return; }
  Promise.resolve(attempt).catch(() => {
   if (this.isConnected && generation === this.generation) this.setControl('Afspil video', true);
  }).finally(() => { if (generation === this.generation) this.pending = false; });
 }
 disconnectedCallback() {
  this.cancelResume(); this.generation++; this.abort?.abort(); this.observer?.disconnect(); this.childObserver?.disconnect(); this.video?.pause(); this.ready = false;
 }
});
